// 노출 토글 기본값
export const FILTER_VISIBILITY_DEFAULTS = {
  room_cnt: true,
  bath_cnt: true,
  fee_year: true,      // 보증금
  fee_month: true,     // 월세
  floor: true,

  owner_household: true, // 주인세대 여부
  owner_room: false,
  owner_bath: false,

  sale_type_sub_rent: true,    // 임대승계 매매
  sale_type_sub_living: true,  // 입주가능 매매

  living_condition_ev: false,                // 승강기
  internal_condition_interior: false,       // 인테리어
  internal_condition_water: false,          // 수도시설
  internal_condition_city_gas: false,       // 도시가스
  bath_division: false                      // 화장실 남녀구분
};

// 검색 값 기본
export const DEFAULT_FILTERS = {
  room_cnt_min: "", room_cnt_max: "",
  bath_cnt_min: "", bath_cnt_max: "",
  fee_sale_min: "", fee_sale_max: "",   // 매매금액(만) — 서버에서 price_sale 로 조회
  fee_year_min: "", fee_year_max: "",
  fee_month_min: "", fee_month_max: "",
  floor_min: "", floor_max: "",

  owner_household: "",   // "y" | ""
  owner_room_min: "", owner_room_max: "",
  owner_bath_min: "", owner_bath_max: "",

  sale_type_sub_rent: "",    // "y" | ""
  sale_type_sub_living: "",  // "y" | ""

  living_condition_ev: "",                // "y" | ""
  internal_condition_interior: "",
  internal_condition_water: "",
  internal_condition_city_gas: "",
  bath_division: ""
};
